import { ApiEndpoints } from "@shared/api/api-endpoints";
import { mxApiClient } from "@shared/api/clients/apiClientFactory";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";


// Add your feature-specific API calls here
export const mxSharedApi = {
 getNotes: async (id: string, type: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "mx",
      `notes`,
      (query) => {
        query.push("remote_utility_id", getRemoteUtilityId());
        query.push("entity_type", type);
        query.push("entity_id", id);
        return query;
      }
    );
    const response = await mxApiClient.get(url);
    return response.data ?? [];
  },

   createNote: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("mx", "notes");
    const response = await mxApiClient.post(url, payload);
    return response.data;
  },

    getActivityLog: async (id: string, type: string) => {
      const url = ApiEndpoints.createUrlWithQueryParameters(
        "mx",
        `activity-log`,
        (query) => {
          query.push("remote_utility_id", getRemoteUtilityId());
          query.push("patient_id", id);
          query.push("entity_type", type);
          return query;
        }
      );
      const response = await mxApiClient.get(url);
      return response.data ?? [];
    },
};
